import { render, staticRenderFns } from "./ShippingAdminBtns.vue?vue&type=template&id=afe91420&scoped=true"
import script from "./ShippingAdminBtns.vue?vue&type=script&lang=js"
export * from "./ShippingAdminBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe91420",
  null
  
)

export default component.exports